import reducer from "./reducers";

export { default as tipOperations } from "./operations";

export default reducer;
